import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '../utils/http'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('../index.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/package',
        name: 'Package',
        component: () => import('../views/package.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/packagedetails',
        name: 'PackageDetails',
        component: () => import('../views/packagedetails.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/order',
        name: 'Order',
        component: () => import('../views/order.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/orderShow',
        name: 'OrderShow',
        component: () => import('../views/orderShow.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/coupon',
        name: 'Coupon',
        component: () => import('../views/coupon.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('../views/address.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/receive',
        name: 'Receive',
        component: () => import('../views/receive.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/forecast',
        name: 'Forecast',
        component: () => import('../views/forecast.vue'),
        meta: { requiresAuth: true }
    },
    {
        // 其他路径重定向到首页
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'hash', // 使用 hash 模式，避免企业微信环境下的路径问题
    routes
})

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
    const loggedIn = isLoggedIn()
    
    if (to.meta.requiresAuth && !loggedIn) {
        // 需要登录但未登录，跳转登录页
        next('/login')
    } else if (to.path === '/login' && loggedIn) {
        // 已登录但访问登录页，跳转首页
        next('/')
    } else {
        next()
    }
})

export default router
